import { Autocomplete, Box, Paper, TextField, ThemeProvider, createTheme, useTheme } from '@mui/material';
import { type Props } from './types.ts';

export const GenreMultiSelectDropdown = ({ ariaLabelledBy, name, options, setFieldValue, value }: Props) => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={createTheme({ ...theme, palette: { mode: 'dark' } })}>
      <Autocomplete
        aria-labelledby={ariaLabelledBy}
        autoComplete
        clearIcon=""
        filterSelectedOptions
        getOptionLabel={option => option.name}
        includeInputInList
        multiple
        noOptionsText=""
        onChange={(_e, option) => {
          void setFieldValue(name, option);
        }}
        options={options}
        renderInput={params => <TextField {...params} fullWidth hiddenLabel placeholder="Enter name" />}
        renderOption={(props, renderOpts) => (
          <Box component="li" {...props} key={renderOpts.id}>
            {renderOpts.name}
          </Box>
        )}
        slots={{
          paper: params => <Paper {...params} sx={{ backgroundColor: '#222' }} />,
        }}
        value={value}
      />
    </ThemeProvider>
  );
};
